import { tap, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '../../services';

import { Operator, OperatorUser } from './operator.model';

import { mapData, mapSuccess } from '../rxjs';
import { OperatorPackage } from '..';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../shared/services/toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class OperatorService {
  constructor(
    private _http: HttpInterceptorService,
    private toastService: ToastService,
    private dialog: DialogService,
    private translate: TranslateService
  ) {}

  getOperatorsCanSee() {
    return this._http.get('Operators/OperatorsICanSee').pipe(
      mapData(),
      tap({
        error: (err) => {
          this.toastService.error(err);
        }
      })
    );
  }
  // @TODO: Feels like an antiparten to write it this way;
  getSingle(operatorID: number) {
    return this._http.get(`Operators/${operatorID}`).pipe(
      mapData(),
      tap({
        error: (err) => {
          this.toastService.error(err);
        }
      })
    );
  }
  getUsers(operatorID: number) {
    return this._http.get(`Operators/GetAllUsers/${operatorID}`).pipe(
      mergeMap(mapData()),
      mergeMap(mapSuccess()),
      tap({
        next: (data: any) => {
          if (data.success) {
            return data.datas;
          } else {
            this.toastService.error();
            return [];
          }
        },
        error: (err) => {
          this.toastService.error(err);
          return [];
        }
      })
    );
  }
  add(operator: Operator, operatorPackage: OperatorPackage) {
    operator.isActive = true;

    return this._http.post('Operators', { Operator: operator, Package: operatorPackage }).pipe(
      mapData(),

      tap({
        error: (err) => {
          this.toastService.error(err);
        }
      })
    );
  }

  addUser(operatorUser: OperatorUser) {
    return this._http.post('Operators/AddUserAccess', operatorUser).pipe(
      mapSuccess(),
      tap({
        next: (success) => {
          if (!success) {
            this.toastService.error();
            return false;
          }

          return success;
        },
        error: (err) => {
          this.toastService.error(err);
        }
      })
    );
  }
  updateUser(operatorUser: OperatorUser) {
    return this._http.put('Operators/ChangeUserAccess', operatorUser).pipe(
      mapSuccess(),
      tap({
        error: (err) => {
          this.toastService.error(err);
        }
      })
    );
  }
  deleteUser(operatorUser: OperatorUser) {
    return this.dialog
      .prompt(this.translate.instant('CONFIRM_REMOVE_USER_OPERATOR'), null, this.translate.instant('REMOVE'))
      .pipe(
        tap({
          next: (doDelete) => {
            if (doDelete) {
              return this._http.delete(
                'Operators/RemoveUserAccess/' + operatorUser.FK_UserID + '/' + operatorUser.FK_OperatorID
              );
            }
            return false;
          }
        }),
        tap({
          next: (res) => {
            if (res.success) {
              return true;
            } else {
              this.toastService.error();
              return false;
            }
          },
          error: (err) => {
            this.toastService.error(err);
            return false;
          }
        })
      );
  }

  saveOperator(operator: Operator) {
    return this._http.put('Operators', operator).pipe(
      mapSuccess(),
      tap({
        next: (success) => {
          if (!success) {
            this.toastService.error();
            return false;
          }

          return success;
        },
        error: (err) => {
          this.toastService.error(err);
        }
      })
    );
  }
}
